






import { ref, PropType, onMounted, watch } from 'vue';
import Sortable, { MultiDrag, GroupOptions } from 'sortablejs';
import { useSortableManager } from '../../../shared/composables/useSortableManager';

Sortable.mount(new MultiDrag());

export default {
  name: 'CustomDraggable',
  props: {
    group: { type: [String, Object] as PropType<string | GroupOptions>, default: 'default' },
    draggable: { type: String, default: null },
    animation: { type: Number, default: 150 },
    disabled: { type: Boolean, default: false },
    multiDrag: { type: Boolean, default: false },
    ghostClass: { type: String, default: 'ghost' },
    dragClass: { type: String, default: 'drag' },
    filter: { type: String, default: '' },
    useChildRef: { type: Boolean, default: false }, // Use child ref as Sortable ref
    selectedClass: { type: String, default: 'sortable-selected' }, // Selected class for MultiDrag
    multiSelectedClass: { type: String, default: 'selected' }, // Selected class in multi select mode
  },
  emits: ['start', 'end', 'move'],
  setup(props, { emit }) {
    const DEFAULT_FALLBACK_TOLERANCE = 5;
    const container = ref(null);
    let sortableInstance: Sortable | null = null;

    const initializeSortable = () => {
      if (!container.value) {
        return;
      }
      let sortableContainer = container.value;
      if (props.useChildRef && container.value.firstElementChild instanceof HTMLElement) {
        sortableContainer = container.value.firstElementChild;
      }
      sortableInstance = new Sortable(sortableContainer, {
        avoidImplicitDeselect: true,
        forceFallback: true,
        fallbackTolerance: DEFAULT_FALLBACK_TOLERANCE,
        sort: false,
        removeCloneOnHide: false,
        group: props.group,
        animation: props.animation,
        disabled: props.disabled,
        ghostClass: props.ghostClass,
        dragClass: props.dragClass,
        selectedClass: props.selectedClass,
        multiDrag: props.multiDrag,
        multiDragKey: 'CTRL',
        filter: (evt, el) => {
          const selectedCount =
            document.querySelectorAll(`.${props.draggable}.${props.multiSelectedClass}`)?.length || 0;
          return (
            el.classList.contains(props.filter) ||
            (!el.classList.contains(props.multiSelectedClass) && selectedCount > 0)
          );
        },
        onStart: evt => {
          const items = [];
          const containers = Array.from(
            document.querySelectorAll(`.${props.draggable}.${props.multiSelectedClass}:not(.sortable-fallback)`)
          ).filter(el => getComputedStyle(el).display !== 'none');
          for (const element of containers) {
            if (element instanceof HTMLElement) {
              Sortable.utils.select(element);
              items.push(element);
            }
          }
          evt.items = items;
          emit('start', evt);
        },
        onEnd: evt => {
          emit('end', evt);
        },
        onMove: evt => {
          emit('move', evt);
          return false;
        },
      });

      useSortableManager(sortableInstance);
    };

    onMounted(() => {
      initializeSortable();
    });

    watch(
      () => props.disabled,
      isDisabled => {
        if (sortableInstance) {
          sortableInstance.option('disabled', isDisabled);
        }
      }
    );

    return {
      container,
    };
  },
};
